/**
 * A verified bank account of a merchant, as returned by
 * GET organizations/{id}/merchants/{countryCode}/{organizationNumber}/bankaccounts. Only verified accounts
 * (through the Bits bank account workflow) are returned. The IBAN is what the onboarding request carries back
 * as the settlement account of the store; the currency decides which store countries the account
 * can settle (see getOnboardingCountryCurrency); the id is the Bits bank account id.
 */
export interface MerchantBankAccount {
    id: string;
    iban: string;
    /** ISO 4217 code, e.g. SEK. */
    currency: string;
}

/** IBAN grouped in blocks of four for display. */
export const formatIban = (iban: string) =>
    iban
        .replace(/\s+/g, '')
        .replace(/(.{4})/g, '$1 ')
        .trim();
